import { useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import options2Fill from '@iconify/icons-eva/options-2-fill';
import { alpha } from '@mui/material/styles';
import { Box, Stack, Typography, Divider } from '@mui/material';
import { MIconButton } from 'components/@material-extend';
import MenuPopover from 'components/MenuPopover';
import Scrollbar from 'components/Scrollbar';
import SettingMode from 'components/settings/SettingMode';
import SettingColor from 'components/settings/SettingColor';

export default function SettingsPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        size='large'
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}
      >
        <Icon icon={options2Fill} width={20} height={20} />
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 260 }} disableScrollLock>
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Typography variant='subtitle1'>Appearance</Typography>
        </Box>

        <Divider />

        <Scrollbar sx={{ height: { xs: 340, sm: 400 } }}>
          <Stack spacing={4} sx={{ pt: 3, px: 3, pb: 3 }}>
            <Stack spacing={1.5}>
              <Typography variant='subtitle2'>Theme</Typography>
              <SettingMode />
            </Stack>

            <Stack spacing={1.5}>
              <Typography variant='subtitle2'>Brand color</Typography>
              <SettingColor />
            </Stack>
          </Stack>
        </Scrollbar>
      </MenuPopover>
    </>
  );
}
